import React, { useState, useEffect, useRef } from 'react'
import { Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import { ResetSuccessSVG } from 'assets/svg'
import { useAuth } from 'stores/recoil'
import { appSettings, route } from 'settings'
import { ElementComponent } from 'components'
import { general } from 'utils'
import { useResponsive } from 'hooks'

function ForgetSuccessPage() {
  const { isMobile } = useResponsive()
  const navigate = useNavigate()
  const contentRef = useRef<HTMLDivElement | null>(null)

  const [user, setUser] = useState({ username: '', password: '' })
  const [, setToken] = useRecoilState(useAuth.selector.selectorToken)

  const getAccount = async () => {
    try {
      const { forgetPasswordSet } = await JSON.parse(
        general.cookie.getCookie(appSettings.USER_KEY),
      )

      if (forgetPasswordSet) {
        setUser({
          username: forgetPasswordSet.phoneNumber,
          password: forgetPasswordSet.password,
        })

        general.cookie.setCookie(
          appSettings.TOKEN_KEY,
          forgetPasswordSet.refreshToken,
        )
        setToken(forgetPasswordSet.accessToken)
      }
    } catch {
      general.http.redirect()
    }
  }

  const handleHeightContent = () => {
    if (contentRef) {
      const height = window.innerHeight - contentRef.current?.clientHeight

      if (height < 90) return 'mt-[90px]'
    }
  }

  useEffect(() => {
    getAccount()
  }, [])

  return (
    <div className="laptop:bg-white-darker bg-white-main h-full relative overflow-auto">
      <div
        ref={contentRef}
        className={`py-[40px] px-[18px] flex flex-col items-center rounded-[15px] laptop:text-[18px] text-[16px] bg-white-main w-full max-w-[900px] absolute top-1/2 left-1/2 ${handleHeightContent()}`}
        style={{ transform: 'translate(-50%, -50%)' }}
      >
        <p
          id="success-message-forget-password"
          className="text-[32px] text-blue-main"
        >
          รีเซ็ตรหัสผ่านสำเร็จ
        </p>
        <ResetSuccessSVG className="mt-[40px] mb-[30px] w-full" />
        <p>ระบบได้ทำการรีเซ็ตรหัสผ่านใหม่ของคุณเรียบร้อยแล้ว</p>
        <p className="text-red-main">
          หมายเหตุ * กรุณาจดบันทึกรหัสนี้ หรือ ทำการบันทึกหน้าจอไว้
        </p>

        <div className="text-start mt-[20px] mb-[40px]">
          <p>{`ชื่อผู้ใช้งาน : ${user.username}`}</p>
          <p>{`รหัสผ่าน : ${user.password}`}</p>
        </div>

        <Stack
          direction={{ mobile: 'column', laptop: 'row' }}
          gap="20px"
          className="w-full justify-center max-w-[500px] p-[18px]"
        >
          <div className="order-2 laptop:order-1">
            <ElementComponent.Button
              id="back-to-home-button"
              height="52px"
              width={isMobile ? '100%' : '240px'}
              text="กลับสู่หน้าหลัก"
              shape="outlined"
              onAction={() => navigate(route.LANDING_PAGE_URL)}
            />
          </div>
          <div className="order-1 laptop:order-2">
            <ElementComponent.Button
              id="go-to-health-monitoring-button"
              height="52px"
              width={isMobile ? '100%' : '240px'}
              text="เข้าสู่ Health Monitoring"
              onAction={() => navigate(route.OVERVIEW_PAGE_URL)}
            />
          </div>
        </Stack>
      </div>
    </div>
  )
}

export default ForgetSuccessPage
